import { observer } from "mobx-react-lite";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import {
  BaseMinimapSectionItem,
  type MinimapSectionItemProps,
} from "./BaseMinimapSectionItem";

export const AmrapMinimapSectionItem = observer(
  function AmrapMinimapSectionItem(props: MinimapSectionItemProps) {
    const workoutEditStore = useWorkoutEditStore();
    const workoutItem = workoutEditStore.getGroupWorkoutItemById(props.id);

    return (
      <BaseMinimapSectionItem
        {...props}
        badges={
          workoutItem.durationMinutes ? (
            <span className="text-[10px] px-1 rounded shrink-0 text-slate-500">
              {workoutItem.durationMinutes} min
            </span>
          ) : null
        }
      />
    );
  },
);
